
import * as React from 'react';
import * as _ from 'lodash/fp';
import styled from 'styled-components';

import { NumberInput } from '@process-advisor/process-miner/components/decompositionTree/numberInput';
import { type MinMaxProps } from '@process-advisor/process-miner/api/methods/decompositionTree/setMinMaxTasks'
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

const Wrapper = styled.div`
    display: flex;
`;

const StyledNumberInput = styled(NumberInput)`
    margin-right: 10px;
`;

export const MinMaxTasks: React.FC = () => {
    let [minmax, setMinMax] = React.useState<MinMaxProps>({
        min: 0,
        max: 999999999,
    });

    const onChange = _.curry((key: keyof MinMaxProps, value: number) => {
        setMinMax({ ...minmax, [key]: value });
    });

    const onBlur = _.curry((key: keyof MinMaxProps, value: number) => {
        apiProvider.setDecompositionTreeMinMaxTasks(minmax);
    });

    React.useEffect(() => {
        setMinMax(apiProvider.getDecompositionTreeMinMaxTasks());
    }, []);

    return (
        <Wrapper>
            <StyledNumberInput
                label='Min'
                value={minmax.min}
                onChange={onChange('min')}
                onBlur={onBlur('min')}/>
            <NumberInput
                label='Max'
                value={minmax.max}
                onChange={onChange('max')} 
                onBlur={onBlur('min')}/>
        </Wrapper>
    );
};
